<!-- Card Wrapper (optional) -->
<div *ngIf="showCard; else chartOnly" class="bg-white dark:bg-surface-1 rounded-xl h-full flex flex-col"
  [ngClass]="cardClass" [style.padding]="cardPadding">
  <!-- Header Section -->
  <div *ngIf="title || subtitle" class="mb-4" [ngClass]="headerClass">
    <h3 *ngIf="title" class="text-base text-[#141437] dark:text-white m-0 mb-1 leading-snug" [ngClass]="titleClass">{{
      title }}</h3>
    <p *ngIf="subtitle" class="text-sm text-gray-500 dark:text-slate-400 m-0 leading-snug" [ngClass]="subtitleClass">{{
      subtitle }}</p>
  </div>

  <!-- Legend (Top Position) -->
  <div *ngIf="showLegend && legend.position === 'top'" class="flex flex-wrap pt-3"
    [ngClass]="[legendClass, legend.align === 'start' ? 'justify-start' : legend.align === 'end' ? 'justify-end' : 'justify-center']"
    [style.gap.px]="legend.itemGap || 24">
    <div *ngFor="let item of legendItems"
      class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80">
      <span *ngIf="!item.isLine" class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
      <span *ngIf="item.isLine" class="w-6 h-0.5 shrink-0 rounded-full" [style.background]="item.color"></span>
      <span class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
        [ngClass]="legendLabelClass">{{ item.name }}</span>
    </div>
  </div>

  <!-- Chart Container with Legend Layout -->
  <div class="flex flex-1 min-h-0 gap-4" [class.flex-row]="legend.position === 'left' || legend.position === 'right'">
    <!-- Legend (Left Position) -->
    <div *ngIf="showLegend && legend.position === 'left'" class="flex flex-col justify-center px-2"
      [ngClass]="legendClass" [style.gap.px]="legend.itemGap || 12">
      <div *ngFor="let item of legendItems"
        class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80">
        <span *ngIf="!item.isLine" class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
        <span *ngIf="item.isLine" class="w-6 h-0.5 shrink-0 rounded-full" [style.background]="item.color"></span>
        <span class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
          [ngClass]="legendLabelClass">{{ item.name }}</span>
      </div>
    </div>

    <!-- Chart Container -->
    <div #chartContainer class="flex-1 min-h-[200px] relative w-full"
      [style.height.px]="height !== 'auto' ? height : null"></div>

    <!-- Legend (Right Position) -->
    <div *ngIf="showLegend && legend.position === 'right'" class="flex flex-col justify-center px-2"
      [ngClass]="legendClass" [style.gap.px]="legend.itemGap || 12">
      <div *ngFor="let item of legendItems"
        class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80">
        <span *ngIf="!item.isLine" class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
        <span *ngIf="item.isLine" class="w-6 h-0.5 shrink-0 rounded-full" [style.background]="item.color"></span>
        <span class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
          [ngClass]="legendLabelClass">{{ item.name }}</span>
      </div>
    </div>
  </div>

  <!-- Legend (Bottom Position) -->
  <div *ngIf="showLegend && legend.position === 'bottom'" class="flex flex-wrap pt-3"
    [ngClass]="[legendClass, legend.align === 'start' ? 'justify-start' : legend.align === 'end' ? 'justify-end' : 'justify-center']"
    [style.gap.px]="legend.itemGap || 24">
    <div *ngFor="let item of legendItems"
      class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80">
      <span *ngIf="!item.isLine" class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
      <span *ngIf="item.isLine" class="w-6 h-0.5 shrink-0 rounded-full" [style.background]="item.color"></span>
      <span class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
        [ngClass]="legendLabelClass">{{ item.name }}</span>
    </div>
  </div>
</div>

<!-- Chart Only (no card wrapper) -->
<ng-template #chartOnly>
  <div class="w-full h-full flex flex-col">
    <!-- Legend (Top Position) -->
    <div *ngIf="showLegend && legend.position === 'top'" class="flex flex-wrap pt-3"
      [ngClass]="[legendClass, legend.align === 'start' ? 'justify-start' : legend.align === 'end' ? 'justify-end' : 'justify-center']"
      [style.gap.px]="legend.itemGap || 24">
      <div *ngFor="let item of legendItems"
        class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80">
        <span *ngIf="!item.isLine" class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
        <span *ngIf="item.isLine" class="w-6 h-0.5 shrink-0 rounded-full" [style.background]="item.color"></span>
        <span class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
          [ngClass]="legendLabelClass">{{ item.name }}</span>
      </div>
    </div>

    <div class="flex flex-1 min-h-0 gap-4" [class.flex-row]="legend.position === 'left' || legend.position === 'right'">
      <!-- Legend (Left Position) -->
      <div *ngIf="showLegend && legend.position === 'left'" class="flex flex-col justify-center px-2"
        [ngClass]="legendClass" [style.gap.px]="legend.itemGap || 12">
        <div *ngFor="let item of legendItems"
          class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80">
          <span *ngIf="!item.isLine" class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
          <span *ngIf="item.isLine" class="w-6 h-0.5 shrink-0 rounded-full" [style.background]="item.color"></span>
          <span class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
            [ngClass]="legendLabelClass">{{ item.name }}</span>
        </div>
      </div>

      <!-- Chart Container -->
      <div #chartContainer class="flex-1 min-h-[200px] relative w-full"
        [style.height.px]="height !== 'auto' ? height : null"></div>

      <!-- Legend (Right Position) -->
      <div *ngIf="showLegend && legend.position === 'right'" class="flex flex-col justify-center px-2"
        [ngClass]="legendClass" [style.gap.px]="legend.itemGap || 12">
        <div *ngFor="let item of legendItems"
          class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80">
          <span *ngIf="!item.isLine" class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
          <span *ngIf="item.isLine" class="w-6 h-0.5 shrink-0 rounded-full" [style.background]="item.color"></span>
          <span class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
            [ngClass]="legendLabelClass">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <!-- Legend (Bottom Position) -->
    <div *ngIf="showLegend && legend.position === 'bottom'" class="flex flex-wrap pt-3"
      [ngClass]="[legendClass, legend.align === 'start' ? 'justify-start' : legend.align === 'end' ? 'justify-end' : 'justify-center']"
      [style.gap.px]="legend.itemGap || 24">
      <div *ngFor="let item of legendItems"
        class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80">
        <span *ngIf="!item.isLine" class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
        <span *ngIf="item.isLine" class="w-6 h-0.5 shrink-0 rounded-full" [style.background]="item.color"></span>
        <span class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
          [ngClass]="legendLabelClass">{{ item.name }}</span>
      </div>
    </div>
  </div>
</ng-template>